import React from "react";

export const isValidPhone = (v) => /^[6-9]\d{9}$/.test(v || "");

export default function PhoneInput({ value, onChange, testid, error }) {
  return (
    <div>
      <div className={`flex h-12 rounded-xl border bg-white overflow-hidden focus-within:border-[#E05624] transition ${error ? "border-[#C0392B]" : "border-[#E5E0D8]"}`}>
        <span className="px-3 flex items-center bg-[#F3EFEA] text-sm font-bold text-[#121316] border-r border-[#E5E0D8]">+91</span>
        <input data-testid={testid} type="tel" inputMode="numeric" maxLength={10} value={value} required placeholder="98XXXXXXXX"
          onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 10))}
          className="flex-1 min-w-0 px-3 outline-none text-[#121316] bg-transparent" />
      </div>
      {error && <p data-testid={`${testid}-error`} className="mt-1 text-xs font-semibold text-[#C0392B]">{error}</p>}
    </div>
  );
}

export function Honeypot({ value, onChange }) {
  return <input type="text" name="website" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} className="hidden" aria-hidden="true" />;
}
